import React from 'react'
import { WhiteBox } from '@/components/Layout'
import { localized } from '@/decorators/localized'
import { FileAttachments, defaultChangeHandler, operations } from '@/components/fileAttachments'
import LoadingIndicator from '@/components/LoadingIndicator'
import { DataLoader } from '@/components/dataLoader'

@localized()
class ReportAttachments extends React.Component {
   state = {
     attachments: [],
     counter: 0
   }
  updateAttachments = () => {
    this.props.addAttachments({
      entityId: this.props.parentId,
      fileIds: this.state.attachments.map(x => x.id)
    })
  }
  onAttachmentChange = (e) => {
    this.setState(
      { attachments: defaultChangeHandler(e, this.state.attachments) },
      () => {
        if (e.operation === operations.remove) { this.props.removeAttachment(e.file.id) }
      }
    )
  }
  renderAttachments (parentId) {
    return (
      <DataLoader
        dataSource={this.props.dataSource}
        render={({ data, loading }) => {
          if (loading) {
            return (<LoadingIndicator />)
          }
          if (data && this.state.counter !== data.length + this.state.attachments.length) {
            this.setState({ counter: data.length + this.state.attachments.length })
          }
          return (
            <FileAttachments
              readonly={this.props.disabled}
              attachments={[...data, ...this.state.attachments]}
              downloadAction={this.props.downloadAction}
              onFilesAdded={this.updateAttachments}
              onChange={this.onAttachmentChange} />
          )
        }
        } />
    )
  }
  render () {
    if (this.props.adding === true) { return <LoadingIndicator /> }
    const { localize, parentId, collapse, collapsed } = this.props
    return (
      <WhiteBox
        collapse={collapse}
        collapsed={collapsed}
        header={localize('Common.Attachments') + ' (' + this.state.counter + ')'}
      >
        {this.renderAttachments(parentId)}
      </WhiteBox>
    )
  }
}

export default ReportAttachments



// WEBPACK FOOTER //
// ./src/components/reporting/reportAttachments.js